import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import RouterWrapper from '../../../../utils/RouterWrapper';
import DealActions from '../../../../actions/DealActions';
import HotelActions from '../../../../actions/HotelActions';
import Analytics from 'arbitrip-common/client/analytics';
import ResultsStore from '../../../../stores/ResultsStore';
import { useTranslation } from 'react-i18next';

const NoDealComponent = ({ deal, hotel, searchToken, searchTerms, profile }) => {
	const { t } = useTranslation();

	const handleOnSelectClick = () => {
		HotelActions.getHotelData(hotel);
		if (deal) {
			DealActions.chooseDeal(deal);
		}

		const recommended_index = ResultsStore.calculateRecommendedIndex(hotel);
		HotelActions.setHotelRecommendedIndex(hotel.id, recommended_index);

		const recommended_count = ResultsStore.getRecommendedCount();
		const sort_method = ResultsStore.getSortMethod();
		const time_to_click_ml = ResultsStore.getTimePassedSinceSearchSessionCreatedInMilliSeconds();
		Analytics.actions.interactions.selectedHotel(
			profile,
			searchTerms.destination,
			searchTerms,
			recommended_index,
			recommended_count,
			sort_method,
			time_to_click_ml,
		);
		HotelActions.setHotelScroll(window.scrollY, hotel.id);
		window.open(RouterWrapper.buildHotelRoute(hotel, undefined, searchTerms), '_blank');
	};

	return (
		<div className="no-deal-shallow-wrapper">
			<div className="shallow">
				<span>{t('NoAvailability')}</span>
			</div>
			<div className="shallow-action select-action">
				<Button className="check-availability-button" onClick={handleOnSelectClick} disableRipple>
					{t('CheckAvailability')}
				</Button>
			</div>
		</div>
	);
};

export default NoDealComponent;
